import React, { useState, useEffect } from 'react'

export default function DonationsReport({report, donor_title}) {
    const [donationReport, setDonationReport] = useState(report)
    const [fields, setFields] = useState(["Invoice Number", "Invoice Type", "Payment Date", "Method", "Payment Amount", "Invoice Amount"])

    const getInvoiceBalance = (total_cost, balance, status, invoice) => {
        let total_amount = getInvoiceAmount(invoice)
        let message = ''
        let amount = parseFloat(total_amount) - parseFloat(balance)
        if (amount < 0) amount = 0
        message = `$${parseInt(amount).toFixed(2)}`
        if (status == 'paid')  {
            message = "Fully Paid"
        }

        return message
    }

    const getInvoiceAmount = (invoice) => {
        if (!invoice.use_stripe || (invoice.use_stripe && !invoice.pass_processing_fee)) {
            return invoice.total_invoice_cost
        }

        if (invoice.isRecurring) {
            let amount = parseInt(invoice.total_invoice_cost) * 0.034 + 0.30
            amount = parseFloat(invoice.total_invoice_cost) + amount
            return amount
        }

        if (!invoice.isRecurring) {
            let amount = parseInt(invoice.total_invoice_cost) * 0.029 + 0.30
            amount = parseFloat(invoice.total_invoice_cost) + amount
            return amount
        }
    }
  return (
    <div>
        <div className="table-responsive">
            <table className="table table-striped table-hover table-fixed mt-5 text-align-left">
                <thead className="thead-dark-custom">
                    <tr>
                        <th className="border-right">{ fields[0] }</th>
                        <th className="border-right">{ fields[1] }</th>
                        <th className="border-right">{ fields[2] }</th>
                        <th className="border-right">{ fields[3] }</th>
                        <th className="border-right">{ fields[4] }</th>
                        <th className="border-right">{ fields[5] }</th>
                    </tr>
                </thead>
                <tbody>
                    {donationReport.length > 0 && donationReport.map(report => (
                        <>
                        {report.invoice.payments.map(payment => (
                            <tr key={payment.id} className="border-bottom">
                                <td className="border-right border-left">
                                    <a href={`/d/${report.donor.id}/invoices/${report.invoice.id}`} target="_blank">
                                        { report.invoice.invoice_number }
                                    </a>
                                </td>

                                <td className="border-right">
                                    {report.invoice.isRecurring && "Recurring Invoice"}
                                    {!report.invoice.isRecurring && "Single Invoice"}
                                </td>

                                <td className="border-right">
                                    { `${payment.date}` }
                                </td>

                                <td className="border-right">
                                    { `${payment.method}` }
                                </td>

                                <td className="border-right">
                                    ${ `${parseInt(payment.amount).toFixed(2)}` }
                                </td>

                                <td className="border-right">
                                    ${ `${parseInt(getInvoiceAmount(report.invoice)).toFixed(2)}` }
                                </td>
                            </tr>
                        ))}
                        </>
                     ))}
                </tbody>
            </table>
         </div>
    </div>
  )
}